import connect from '../socket/services/connect'
import { post } from './axios'
import constants from '../utils/constants'
import JUDITE_API_ROUTES from '../routes/judite-api-routes'
import { set } from '../utils/session-handler'

const authenticate = async (username, password) => {
  try {
    const session = await post(
      `${constants.JUDITE_API_ENDPOINT}${JUDITE_API_ROUTES.LOGIN}`,
      {
        username,
        password,
      },
    )

    connect(session.ws_username, session.ws_password)

    set('username', username)
    set('name', session.name)

    return true
  } catch (error) {
    return false
  }
}

export { authenticate }
